<script lang="ts">
  import { onMount } from "svelte";
  import {
    headerDisplayStore,
    dialogStore,
    loadingStore,
  } from "../../stores/General";
  import { navigate } from "svelte-navigator";
  import GenericButton from "../button/GenericButton.svelte";
  import { Moon } from "svelte-loading-spinners";
  import CollapseBox from "../../components/form/CollapseBox.svelte";

  import { create, update, remove, getList } from "../../api";
  import { campaignAdEditStore } from "../../stores/Campaign";
  import NewTable, { Column } from "../../components/table/Table.svelte";
  import DynamicDialog from "../../views/overlays/dynamicDialog.svelte";
  import FlightForm from "./FlightForm.svelte";
  import ActivateModal from "../modal/ActivateModal.svelte";
  import { Trash } from "svelte-hero-icons";
  import NoFlightsIcon from "./NoFlightsIcon.svelte";
  import { dateShort } from "../../utils/conv.js";

  const module_name = "flight";
  let selectedIds = [];
  let pageSize = 10;
  let data = [];
  let count = 0;
  let page = 1;
  let sortBy = "start_at";
  let sortOrder = "ASC";
  let width = "120";
  const tableId = "flights";
  let pagination = { page, pageSize, count };

  let FlightFormOpen = false;
  let showDeleteModal = false;
  let modalData: any = {};
  let filters = {};
  let flight = null;

  export let campaign_id = "";
  export let targeting = null;

  const columns: Column[] = [
    {
      label: "Placement ID",
      dataKey: "name",
      renderBy: "formatter",
      width,
    },
    {
      label: "Budget Allocation",
      dataKey: "budget",
      renderBy: "formatter",
      width,
    },
    {
      label: "Budget",
      dataKey: "budget",
      renderBy: "formatter",
      width,
    },
    {
      label: "Impressions",
      dataKey: "impressions",
      renderBy: "formatter",
      width,
    },
    {
      label: "Start Date",
      dataKey: "start_at",
      renderBy: "formatter",
      formatter: dateShort,
      sortBy: "start_at",
      width,
    },
    {
      label: "End Date",
      dataKey: "end_at",
      renderBy: "formatter",
      formatter: dateShort,
      sortBy: "end_at",
      width,
    },
    {
      label: "Status",
      dataKey: "status",
      renderBy: "formatter",
      width,
    },
    {
      renderBy: "actions",
      width: "110",
      actions: [
        { key: "edit", label: "Edit", icon: "edit" },
        { key: "copy", label: "Copy", icon: "copy" },
        { key: "dlt", label: "Delete", icon: "dlt" },
      ],
    },
  ];

  function editAction(value: any) {
    // console.log({ value });
    flight = value;
    openFlightForm(true);
  }

  function copyAction(value: any) {
    campaignAdEditStore.set(value);
    navigate("/campaign/ad/edit");
  }

  function ToggleModal(value) {
    modalData.flight_id = value.flight_id;
    showDeleteModal = !showDeleteModal;
    modalData.Icon = Trash;
    modalData.headerText = "Delete Flight";
    modalData.body = "Are you sure you want to delete this flight?";
    modalData.rightButtonText = "Delete";
    showDeleteModal = !showDeleteModal;
  }

  function DeleteAction() {
    remove(module_name, [modalData.flight_id])
      .then((response) => {
        if (response?.status === "ok") {
          headerDisplayStore.ShowNotification({
            title: "Success",
            subtitle: "Flight deleted successfully",
          });
          loadData();
        } else {
          headerDisplayStore.ShowError({
            title: "Error",
            subtitle: response?.error,
          });
        }
      })
      .catch((error) => {
        headerDisplayStore.ShowError({
          title: "Server error",
          subtitle: error?.message,
        });
      });
  }

  function handleActionClick({ detail }) {
    const { action, row } = detail;

    switch (action.key) {
      case "edit":
        editAction(row);
        break;
      case "copy":
        copyAction(row);
        break;
      case "dlt":
        ToggleModal(row);
        break;
    }
  }

  function handleCheckedChange(event) {
    selectedIds = event.detail.selectedIds;
  }

  function loadData() {
    if (campaign_id === "") {
      return [];
    }
    let mainSettingsArray = JSON.parse(
      localStorage.getItem(`_tableMainSettings_${tableId}`)
    );

    pagination = { ...pagination, ...mainSettingsArray?.pagination };

    if (pagination !== null) {
      pageSize = pagination.pageSize;
      page = pagination.page;
    }

    data = [];
    loadingStore.on(module_name, { disableGlobalIndicator: true });
    getList(module_name, pageSize, page, sortBy, sortOrder, {
      campaign_id: [campaign_id],
    })
      .then((response) => {
        loadingStore.off(module_name);
        data = response.data;
        pagination.count = response.count;
      })
      .catch((error) => {
        headerDisplayStore.ShowError({
          title: "Server error",
          subtitle: error?.message,
        });
      });
  }

  function handlePageChange(event) {
    let mainSettingsArray = JSON.parse(
      localStorage.getItem(`_tableMainSettings_${tableId}`)
    );

    mainSettingsArray = { ...mainSettingsArray, pagination: event.detail };

    localStorage.setItem(
      `_tableMainSettings_${tableId}`,
      JSON.stringify(mainSettingsArray)
    );

    page = event.detail.page;
    pageSize = event.detail.pageSize;
    loadData();
  }

  function handleSortChange(event) {
    sortBy = event.detail.sortBy;
    sortOrder = event.detail.sortOrder;
    loadData();
  }

  function handleDeleteSelected() {
    const selectedData = data.filter((d) =>
      selectedIds.includes(d.campaign_id)
    );
    dialogStore.openDeletePrompt(module_name, selectedData, () => {
      loadData();
    });
  }

  onMount(() => {
    loadData();
  });

  function openFlightForm(edit: boolean = false) {
    if (!edit) {
      flight = null;
    }
    FlightFormOpen = true;
  }

  function onClose() {
    FlightFormOpen = !FlightFormOpen;
  }

  function onSubmit(e: any) {
    loadingStore.on(module_name, { disableGlobalIndicator: true });
    const data = {
      ...e.detail.data,
      flight_id: flight ? flight.flight_id : "",
      campaign_id: flight ? flight.campaign_id : campaign_id,
    };

    console.log({ data });

    const send = flight ? update : create;
    send(module_name, data)
      .then((response) => {
        loadingStore.off();
        if (response?.status === "ok") {
          headerDisplayStore.ShowNotification({
            title: "Success",
            subtitle: "Flight saved successfully",
          });
          onClose();
          loadData();
        } else {
          headerDisplayStore.ShowError({
            title: "Error",
            subtitle: response?.error,
          });
        }
      })
      .catch((error) => {
        loadingStore.off();
        headerDisplayStore.ShowError({
          title: "Server error",
          subtitle: error?.message,
        });
      });
  }
</script>

<div class="bg-white p-8 pt-4 mt-8 mb-8 w-full rounded-md">
  <CollapseBox title="Flights" show={true} boxStyle="flights">
    <div class="py-2 mb-2 flex flex-row justify-end">
      <GenericButton
        height="2.5rem"
        width="12rem"
        text="New Flight"
        buttonIcon={{ name: "add" }}
        onClick={() => openFlightForm()}
      />
    </div>
    {#if $loadingStore.loading}
      <div class="min-w-full loader-container text-center">
        <div class="align-middle inline-block h-16">
          <Moon size="4" color="#FF3E00" unit="rem" duration="1s" />
        </div>
        <div class="align-middle inline-block h-full" />
      </div>
    {:else if !data.length}
      <div class="flex flex-col items-center justify-center">
        <NoFlightsIcon />
        <h2 class="pt-2 font-bold text-2xl">A little empty here.</h2>
        <p class="py-2 text-sm text-gray-500">
          Add your first flight button below
        </p>
        <GenericButton
          height="2.5rem"
          width="12rem"
          text="Create New Flight"
          buttonIcon={{ name: "add" }}
          onClick={() => openFlightForm()}
        />
      </div>
    {:else if data?.length}
      <NewTable
        bind:data
        {columns}
        {filters}
        dataKey="flight_id"
        loader={$loadingStore.loading}
        {pagination}
        {selectedIds}
        sorting={{ sortBy, sortOrder }}
        defaultConfig={{
          tableId,
          stickyHeader: true,
          showCheckboxes: false,
          stickyFirstColumn: true,
          stickyLastColumn: true,
          multilineColumns: false,
        }}
        on:actionClick={handleActionClick}
        on:checkedChange={handleCheckedChange}
        on:delete={handleDeleteSelected}
        on:pageChange={handlePageChange}
        on:sortClick={handleSortChange}
      />
    {/if}
  </CollapseBox>
</div>

<DynamicDialog
  title={flight ? "Update Flight" : "New Flight"}
  titleClasses="text-left font-bold text-2xl"
  modalClasses="w-4/5"
  bind:showModal={FlightFormOpen}
  {onClose}
>
  <FlightForm
    {flight}
    targeting={flight ? flight.targeting : targeting}
    {onClose}
    {onSubmit}
  />
</DynamicDialog>

{#if showDeleteModal}
  <ActivateModal {modalData} />

  <ActivateModal
    on:click={ToggleModal}
    on:reload={loadData}
    {modalData}
    on:modalSubmit={DeleteAction}
  />
{/if}
